export const inputStyles = "w-full border border-gray-300 rounded-md px-3 py-2.5 text-base focus:outline-none focus:border-orange-600 transition-colors bg-white font-medium";

export const inputStylesCompact = "border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-orange-600 transition-colors bg-white font-medium";
